import React from 'react';
import styled from 'styled-components';
import { LookingAheadData } from '../types/siteDataTypes';
import { Section, Container, SectionHeading } from '../styles/layout';

interface LookingAheadProps {
  data?: LookingAheadData;
}

const SectionTitle = styled(SectionHeading)`
  margin-bottom: 20px;
`;

const CopyBlock = styled.div`
  background: linear-gradient(145deg, rgba(239, 244, 249, 0.6), rgba(223, 231, 240, 0.6));
  border: 1px solid #cfd9e4;
  border-radius: 16px;
  padding: 22px;
  color: #4a5a6b;
  line-height: 1.7;
  text-align: center;
  box-shadow: 0 20px 40px rgba(34, 50, 70, 0.12);

  p {
    margin: 0 0 12px;
  }
`;

const LookingAhead: React.FC<LookingAheadProps> = ({ data }) => {
  return (
    <Section>
      <Container>
        <SectionTitle>
          <h2>{data?.heading || 'Looking Ahead'}</h2>
        </SectionTitle>
        <CopyBlock>
          {data?.paragraphs?.map((text, idx) => (
            <p key={`future-${idx}`}>{text}</p>
          ))}
        </CopyBlock>
      </Container>
    </Section>
  );
};

export default LookingAhead;
